import { z } from "zod";

import i18n from "../../i18n";

export const schema = z.object({
  email: z
    .string()
    .trim()
    .email(i18n.t("deleteGoogleLinkPage.email_format_wrong"))
});

export type Schema = z.infer<typeof schema>;

export const generateDefaultValues = (): Schema => {
  return {
    email: ""
  };
};
